import ObjectID from 'bson-objectid'

export const idGenerator = () => ObjectID().toString()

export const appendUrlParams = (params = {}) => {
  const urlParams = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    urlParams.append(key, value)
  }
  return urlParams
}
